import { render, staticRenderFns } from "./DataConfiguration.vue?vue&type=template&id=3581bdfe&scoped=true"
import script from "./DataConfiguration.vue?vue&type=script&lang=js"
export * from "./DataConfiguration.vue?vue&type=script&lang=js"
import style0 from "./DataConfiguration.scss?vue&type=style&index=0&id=3581bdfe&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3581bdfe",
  null
  
)

export default component.exports